import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'

export default function OpenTickets() {
    const [allTickets, setAllTickets] = useState([])
    const user = JSON.parse(sessionStorage.getItem("User"))

    // Fetch all tickets
    const fetchTickets = async () => {
        try {
            const res = await fetch("https://capobiz-backend.vercel.app/api/auth/tickets", {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            })
            const data = await res.json()
            setAllTickets(data)
        } catch (error) {
            console.error("Error fetching tickets:", error)
            Swal.fire("Error!", "Failed to load tickets.", "error")
        }
    }

    // Delete ticket
    const deleteTicket = async (id) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        })

        if (isConfirmed) {
            try {
                await fetch(`https://capobiz-backend.vercel.app/api/auth/delTicket/${id}`, { method: "DELETE" })
                Swal.fire("Deleted!", "Your ticket has been deleted.", "success")
                fetchTickets()
            } catch (error) {
                console.error("Error deleting ticket:", error)
                Swal.fire("Error!", "Something went wrong while deleting.", "error")
            }
        }
    }

    useEffect(() => {
        fetchTickets()
    }, [])

    const openTickets = allTickets
        .filter(ticket => ticket.userId._id === user._id && ticket.status === "Open")
        .reverse()

    return (
        <div className="container py-4 px-3">
            <h3 className="mb-4 text-center fw-bold text-black">Open Tickets</h3>

            {openTickets.length === 0 ? (
                <div className="text-center py-5">
                    <p className="text-muted fs-5">No open tickets found.</p>
                </div>
            ) : (
                /* Responsive Table Wrapper - Enables horizontal scroll on mobile */
                <div className="table-responsive shadow-lg rounded overflow-hidden">
                    <table className="table table-striped table-hover mb-0 align-middle">
                        <thead className="table-dark text-center text-md-start">
                            <tr>
                                <th className="ps-3">Title</th>
                                <th className="d-none d-md-table-cell">Subject</th>
                                <th>Ticket ID</th>
                                <th className="d-none d-lg-table-cell">Severity</th>
                                <th className="d-none d-xl-table-cell">Message</th>
                                <th>Status</th>
                                <th className="text-center pe-3">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {openTickets.map(ticket => (
                                <tr key={ticket._id}>
                                    <td className="ps-3 fw-medium">
                                        <div className="d-block d-md-none text-muted small mb-1">Title:</div>
                                        {ticket.title}
                                    </td>
                                    <td className="d-none d-md-table-cell">{ticket.subject}</td>
                                    <td className="fw-bold text-primary">
                                        <div className="d-block d-md-none text-muted small mb-1">ID:</div>
                                        {ticket.ticketId}
                                    </td>
                                    <td className="d-none d-lg-table-cell">
                                        <span className={`badge bg-${ticket.severity === 'High' ? 'danger' : ticket.severity === 'Medium' ? 'warning' : 'info'}`}>
                                            {ticket.severity}
                                        </span>
                                    </td>
                                    <td className="d-none d-xl-table-cell text-truncate" style={{ maxWidth: '200px' }}>
                                        {ticket.message}
                                    </td>
                                    <td>
                                        <div className="d-block d-lg-none text-muted small mb-1">Status:</div>
                                        <span className="badge bg-warning text-dark">Open</span>
                                    </td>
                                    <td className="text-center pe-3 py-2">
                                        <button
                                            className="btn btn-danger btn-sm px-3"
                                            onClick={() => deleteTicket(ticket._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Optional: Mobile-friendly card fallback (uncomment if you prefer cards over table on mobile) */}
            {/* 
            <div className="d-md-none mt-4">
                {openTickets.map(ticket => (
                    <div key={ticket._id} className="card mb-3 shadow-sm">
                        <div className="card-body">
                            <h6 className="card-title fw-bold">{ticket.title}</h6>
                            <p className="card-text text-muted small">ID: {ticket.ticketId}</p>
                            <p className="card-text"><strong>Subject:</strong> {ticket.subject}</p>
                            <p className="card-text"><strong>Severity:</strong> 
                                <span className={`ms-2 badge bg-${ticket.severity === 'High' ? 'danger' : 'warning'}`}>
                                    {ticket.severity}
                                </span>
                            </p>
                            <p className="card-text text-muted small">{ticket.message}</p>
                            <div className="text-end">
                                <button className="btn btn-danger btn-sm" onClick={() => deleteTicket(ticket._id)}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            */}
        </div>
    )
}